import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import accordionopen from '../assets/accordionopen.svg';
import akadeetlogo from '../assets/akadeetlogo.png'; // Update the path
import './CustomHeader.css'; // Custom styles for the header
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../store/reduxMasterSlice';
import { hasScreenAccess } from '../utils/screenAccess';

const CustomHeader = (props) => {
    const { setOpen } = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isAuthenticated = useSelector(state => state.reduxMaster.isAuthenticated);
    const screenRights = useSelector(state => state.reduxMaster.screenRights);

    const [isSidebarActive, setIsSidebarActive] = useState(false);

    const sidebarRef = useRef(null); // Create a reference for the sidebar
    const mobileMenuBtnRef = useRef(null); // Create a reference for the mobile menu button

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Clean up the event listener
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Toggle the sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarActive(!isSidebarActive);
    };

    // Close sidebar if clicked outside
    const handleClickOutside = (event) => {
        if (sidebarRef.current && !sidebarRef.current.contains(event.target) && !mobileMenuBtnRef.current.contains(event.target)) {
            setIsSidebarActive(false); // Close sidebar
        }
    };

    const handleLogout = () => {
        dispatch(logout());
        navigate("/", { replace: true });
    }

    const headerMenuItems = (isAuthenticated) => {
        const adminMenuChildren = [
            // { id: 1, menuName: 'Home', navigateurl: '/admin-home' },
            { id: 2, menuName: 'QR Scanner', navigateurl: '/qr-scanner' },
            { id: 3, menuName: `Event's`, navigateurl: '/event-list' },
            { id: 4, menuName: 'Summary Report', navigateurl: '/summary-report' },
            { id: 5, menuName: 'Sponsors List', navigateurl: '/sponsors-list' },
            { id: 6, menuName: 'Applied Stalls', navigateurl: '/apply-stall-list' },
            { id: 7, menuName: 'About Us', navigateurl: '/about-us' },
            // { id: 8, menuName: 'About Event', navigateurl: '/about-event' },
            { id: 8, menuName: `User's`, navigateurl: '/user-list' },
        ].filter((item) => hasScreenAccess(screenRights, item.navigateurl));

        return [
            { id: 1, menuName: 'Home', navigateurl: '/', isShow: isAuthenticated ? false : true },
            ...(isAuthenticated ? [{
                id: 2, menuName: 'Admin Menu', isShow: adminMenuChildren.length > 0,
                children: adminMenuChildren,
            }] : [{
                id: 3, menuName: 'Join Us', isShow: true,
                children: [
                    { id: 1, menuName: 'Sponsor With Us', navigateurl: '/sponsor-with-us' },
                    { id: 2, menuName: 'Book A Stall', navigateurl: '/book-for-stall' },
                ],
            }]),
            { id: 4, menuName: 'About Us', navigateurl: '/about-us', isShow: isAuthenticated ? false : true },
            { id: 5, menuName: 'Blog', navigateurl: '/Blog', isShow: false }
        ];
    };

    return (
        <React.Fragment>
            <header className="custom-header">
                <div className="header-content">
                    {/* Mobile Sidebar Toggle Button */}
                    <div className="mobile-menu-btn" onClick={toggleSidebar} ref={mobileMenuBtnRef}>
                        &#9776; {/* Hamburger icon */}
                    </div>

                    {/* Left: Empty for spacing */}
                    <div className="header-left">
                        <img src={akadeetlogo} alt="Akadeet Logo" className="header-logo" onClick={() => navigate('/')} />
                    </div>

                    {/* Center: Menu items */}
                    <ul className="header-center">
                        {headerMenuItems(isAuthenticated).map((item, index) => (
                            <li key={index} className={item.children ? 'community-link' : ''} onClick={() => item.navigateurl && navigate(item.navigateurl)} style={{ display: item.isShow ? '' : 'none' }}>
                                {item.menuName}
                                {item.children && (
                                    <>
                                        <img src={accordionopen} alt="accordion" />
                                        <ul className="sub-menu">
                                            {item.children.map((sub, subIndex) => (
                                                <li key={subIndex} className="sub-menu-item" onClick={() => navigate(sub.navigateurl)}>{sub.menuName}</li>
                                            ))}
                                        </ul>
                                    </>
                                )}
                            </li>
                        ))}
                    </ul>

                    {/* Right: Login Button (optional) */}
                    <div className="header-right">
                        <button className="login-btn" onClick={() => isAuthenticated ? handleLogout() : setOpen(true)}>{isAuthenticated ? "Logout" : "Login"}</button>
                    </div>
                </div>

                {/* Sidebar for mobile */}
                <div className={`sidebar ${isSidebarActive ? 'active' : ''}`} ref={sidebarRef}>
                    {headerMenuItems(isAuthenticated).map((item, index) => (
                        <div key={index} style={{ display: item.isShow ? '' : 'none' }}>
                            {!item.children ? (
                                <a onClick={() => { setIsSidebarActive(false); navigate(item.navigateurl); }}>{item.menuName}</a>
                            ) : (
                                <a className="sidebar-community-link">
                                    {item.menuName}
                                    <img src={accordionopen} alt="accordion" className="sidebar-icon" />
                                    <ul className="sidebar-sub-menu">
                                        {item.children.map((sub, subIndex) => (
                                            <li key={subIndex} className="sidebar-sub-menu-item" onClick={() => { setIsSidebarActive(false); navigate(sub.navigateurl); }} >{sub.menuName}</li>
                                        ))}
                                    </ul>
                                </a>
                            )}
                        </div>
                    ))}

                    {/* 🔹 Mobile-only Login / Logout */}
                    <div className="sidebar-auth">
                        <a onClick={() => { setIsSidebarActive(false); isAuthenticated ? handleLogout() : setOpen(true); }}>
                            {isAuthenticated ? 'Logout' : 'Login'}
                        </a>
                    </div>
                </div>
            </header>
        </React.Fragment >
    );
};

export default CustomHeader;
